import { ThreatEventCategoryApi, ThreatEventPatternApi, ThreatEventApi } from "@kdmanalytics/brm-system";
import BrmApiClient from "services/brm/BrmApiClient";

export const threatEventCategoryApi = new ThreatEventCategoryApi(BrmApiClient.instance);
export const threatEventPatternApi = new ThreatEventPatternApi(BrmApiClient.instance);
export const threatEventApi = new ThreatEventApi(BrmApiClient.instance);
